import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ADD, REMOVE, VIEW_TYPES, BED_DETAILS_MODULE, DEVICE_TYPES, USER_VIEW } from "../../common/constant/common-constants";
import AnimateBed from "../../common/utils/Animations/AnimateBed";
import { activeDeviceAction, favoriteBedAction, selectedBedAction } from "../../modules/actions/action";
import BedDataContainer from "../BedDataContainer/BedDataContainer";
import "./BedContainer.scss";
import PatientRightPanel from "../PatientRightPanel/PatientRightPanel";
import { bedDetailConfigAction, viewTypeAction } from "../../modules/actions/action";
import { configReducer } from "../../modules/reducers/config-reducer";
import { setbedCartViewRedisChannels } from '../../socket/socket';

function BedContainer(props) {

    // const [favArray, setFavArray] = useState([]);
    const [lvSelectedBed, setLvSelectedBed] = useState(props.selectedBed);
    const [bedArray, setBedArray] = useState([]);

    useEffect(() => {

        // const favBedArray = props.favoriteBedIdArray;

        // let currentBedIdArray = [...props.bedIdArray];

        // let bd = (currentBedIdArray && currentBedIdArray.sort((a, b) => favBedArray.indexOf(b) - favBedArray.indexOf(a))) || [];
        // setBedArray([...bd]);

        sortForFavorite();
    }, [props.favoriteBedIdArray])

    useEffect(() => {

        // const favBedArray = props.favoriteBedIdArray;
        // let currentBedIdArray = [...props.bedIdArray];
        // setBedArray(props.bedIdArray);
        sortForFavorite();
        if (props.bedIdArray && props.bedIdArray.length > 0) {
            // let bd = (bedArray && bedArray.sort((a, b) => favBedArray.indexOf(b) - favBedArray.indexOf(a))) || [];
            // setBedArray([...bd]);
            if (!lvSelectedBed && props.config.viewType === VIEW_TYPES.LIST_VIEW) {
                setLvSelectedBed(props.bedIdArray[0]);
                console.log("this runs on no lvselected");
                props.selectedBedAction(props.bedIdArray[0]);
            };
        }
    }, [props.bedIdArray]);

    useEffect(() => {
        setLvSelectedBed(props.selectedBed);
    }, [])

    const sortForFavorite = () => {
        const favBedArray = props.favoriteBedIdArray;
        // console.log("favbedArray", favBedArray)
        let currentBedIdArray = [...props.bedIdArray];
        let bd = (currentBedIdArray && currentBedIdArray.sort((a, b) => favBedArray.indexOf(b) - favBedArray.indexOf(a))) || [];
        setBedArray([...bd]);
    }

    const handleFavoriteClick = (event, type, bedId) => {
        event.stopPropagation();

        let arr = props.favoriteBedIdArray;
        let index = arr.indexOf(bedId);
        switch (type) {
            case ADD:
                if (index < 0) {
                    arr.push(bedId);
                }
                break;
            case REMOVE:
                if (index > -1) {
                    arr.splice(index, 1);
                }
                break;
            default:
                break;
        }

        props.favoriteBedAction([...arr]);

        // setFavArray([...arr]);
    }

    const handleNotificationClick = (bedId) => {
        // console.log(`notification icon clicked for ${bedId}`);
    }
    // console.log("config", props.config);
    const handleBedClick = (id) => {

        if (!props?.bedDetails[id]?.Noccarc_patientMonitorId && !props?.bedDetails[id]?.ventilatorId) return
        if (lvSelectedBed === id) return
        props.activeDeviceAction(null)
        setLvSelectedBed(id);
        props.selectedBedAction(id);

        props.bedDetailConfigAction({
            activeModule: BED_DETAILS_MODULE.VITAL_DETAILS
        })
        props.viewTypeAction({
            viewType: VIEW_TYPES.LIST_VIEW
        })
    }

    const handleCrossClick = () => {
        setLvSelectedBed(null);
        props.activeDeviceAction(null);
        props.selectedBedAction(null);
        props.viewTypeAction({
            viewType: VIEW_TYPES.GRID_VIEW
        })
        // setbedCartViewRedisChannels(props.selectedWard.id);

    }

    const handleAlarmMoreClick = (id) => {
        setLvSelectedBed(id);

        props.bedDetailConfigAction({
            activeModule: BED_DETAILS_MODULE.ALARMS
        });
        props.viewTypeAction({
            viewType: VIEW_TYPES.LIST_VIEW
        })
    }

    const handleAddPatientClick = (id) => {
        setLvSelectedBed(id);
        props.bedDetailConfigAction({
            activeModule: BED_DETAILS_MODULE.PATIENT_DETAILS
        });
        props.viewTypeAction({
            viewType: VIEW_TYPES.LIST_VIEW
        })
    }

    const getBedArray = () => {

        if (bedArray === null) return;
        let tempBedArray = [...bedArray];

        // to render at the top of the list for the selected bed
        if (lvSelectedBed && tempBedArray && props.config.viewType == VIEW_TYPES.LIST_VIEW) {
            let tempEle = tempBedArray.splice(tempBedArray.indexOf(lvSelectedBed), 1)[0];
            tempBedArray.unshift(tempEle)
            // console.log("tempArray", tempBedArray);
        }

        let html = tempBedArray.map((id) => {

            // let wardId = props.selectedWard.id;

            if (props.wardData && props.wardData.bedList && (props.wardData.bedList.indexOf(id) >= 0)) {
                let ref = React.createRef();
                return (
                    <BedDataContainer
                        key={id}
                        bedId={id}
                        handleFavoriteClick={(event, type, bedId) => handleFavoriteClick(event, type, bedId)}
                        isFavorite={props.favoriteBedIdArray && props.favoriteBedIdArray.indexOf(id) > -1}
                        isSelected={lvSelectedBed}
                        handleBedClick={() => handleBedClick(id)}
                        handleNotificationClick={(bedId) => handleNotificationClick(bedId)}
                        handleAlarmMoreClick={() => handleAlarmMoreClick(id)}
                        handleAddPatientClick={() => handleAddPatientClick(id)}
                        ref={ref}
                    />);
            }
        });

        return html;
    }


    //Set the socket context when ward is changed
    useEffect(() => {

        if (props.selectedWard && props.selectedWard.id && props.config.viewType === VIEW_TYPES.GRID_VIEW) setbedCartViewRedisChannels(props.selectedWard.id);
    }, [props.selectedWard, props.config.viewType]);

    return (
        <>
            <div className="bed-container" style={props.config && props.config.viewType === VIEW_TYPES.GRID_VIEW ? { overflow: 'auto' } : {}}>
                {props.config.userView === USER_VIEW.DESKTOP && (
                    <>
                        <div
                            className={
                                props.config.viewType === VIEW_TYPES.LIST_VIEW
                                    ? "bed-left-panel"
                                    : "bed-grid-data-container"
                            }
                        >
                            <AnimateBed>
                                {getBedArray()}
                            </AnimateBed>
                        </div>

                        {props.config.viewType === VIEW_TYPES.LIST_VIEW && (
                            <div className="right-panel">
                                <PatientRightPanel
                                    wardId={props.selectedWard.id}
                                    bedId={lvSelectedBed}
                                    handleCrossClick={handleCrossClick}
                                />
                            </div>
                        )}
                    </>
                )}

                {props.config.userView === USER_VIEW.MOBILE &&
                    (props.config.viewType === VIEW_TYPES.LIST_VIEW ? (
                        <PatientRightPanel
                            wardId={props.selectedWard.id}
                            bedId={lvSelectedBed}
                            handleCrossClick={handleCrossClick}
                        />
                    ) : (
                        <div className="bed-card-mobile-view-container">
                            <AnimateBed>
                                {getBedArray()}
                            </AnimateBed>
                        </div>
                    ))
                }



            </div>
        </>
    );
}



const mapStateToProps = (state, ownProps) => {
    let wardData = state.wardDetailsReducer.wardData && state.wardDetailsReducer.wardData[ownProps.selectedWard.id];
    let bedDetails = state.bedDetailsReducer.bedDetails;


    return {
        bedDetails: bedDetails,
        bedIdArray: state.bedDetailsReducer.bedIdArray,
        selectedBed: state.bedDetailsReducer.selectedBed,
        wardData: wardData,
        config: state.configReducer.config,
        config: state.configReducer.config,
        favoriteBedIdArray: state.bedDetailsReducer.favoriteBedIdArray || [],
    };
};

const mapDispatchToProps = dispatch => {
    return {
        favoriteBedAction: (payload) => dispatch(favoriteBedAction(payload)),
        activeDeviceAction: (payload) => dispatch(activeDeviceAction(payload)),
        bedDetailConfigAction: (payload) => dispatch(bedDetailConfigAction(payload)),
        viewTypeAction: (payload) => dispatch(viewTypeAction(payload)),
        configReducer: (payload) => dispatch(configReducer(payload)),
        selectedBedAction: (payload) => dispatch(selectedBedAction(payload)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BedContainer);